import { useEffect, useState, createContext, useContext } from 'react';

import { Outlet, useNavigate, useLocation } from 'react-router-dom';

import { useRequest } from 'ahooks';

import { Onboarding as OnboardingService } from '~services';
import { Onboarding, OnboardingStatus } from '~services/types';
import { FullScreenLoading } from '~components';
import { GenericError } from '~containers';

export const OnboardingContext = createContext<Onboarding>(null);

export function useOnboarding() {
  return useContext(OnboardingContext);
}

function OnboardingHandler({ children }: { children?: React.ReactNode }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [onboarding, setOnboarding] = useState<Onboarding>();

  const { loading: isLoadingOnboarding, error } = useRequest(
    OnboardingService.getOnboarding,
    {
      onSuccess: (response) => {
        setOnboarding(response.data.data);
        correctRedirect(response.data.data.status);
      },
      onError: (error) => console.log(error),
    }
  );

  function correctRedirect(status: OnboardingStatus) {
    if (status === 'account-created') {
      navigateIfNotAlready('/representantes/conta-criada');
      return;
    }

    navigateIfNotAlready('/representantes/analise-de-documentos');
  }

  function navigateIfNotAlready(to: string) {
    if (to === location.pathname) return;
    navigate(to);
  }

  useEffect(() => {
    if (onboarding) {
      correctRedirect(onboarding.status);
    }
  }, [location]);

  return (
    <>
      {!isLoadingOnboarding && onboarding && (
        <OnboardingContext.Provider value={onboarding}>
          <Outlet />
          {!!children && children}
        </OnboardingContext.Provider>
      )}
      {isLoadingOnboarding && <FullScreenLoading text="Carregando" />}
      {error && <GenericError />}
    </>
  );
}

export default OnboardingHandler;
